import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30c36798&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=30c36798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c36798",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c36798')) {
      api.createRecord('30c36798', component.options)
    } else {
      api.reload('30c36798', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30c36798&scoped=true&", function () {
      api.rerender('30c36798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/Inspection/index.vue"
export default component.exports